<template>
  <v-dialog v-model="copyScheduleDialog" scrollable>
    <v-snackbar v-model="msg" top
      >{{ text }}
      <v-btn color="red" text @click="msg = false"> Close</v-btn>
    </v-snackbar>
    <v-card>
      <v-card-title>
        Copy Schedule
        <v-spacer />
        <v-btn icon @click="copyScheduleDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col lg="6" md="6" sm="12">
            <p class="mt-3">Choose schedule view</p>
            <v-row>
              <v-select
                v-model="selectedCalendarType"
                :items="calendarTypes"
                class="schedule-field"
                outlined
              ></v-select>
            </v-row>

            <v-row>
              <!-- Copy From -->
              <v-col cols="6" sm="12" md="6">
                <div class="d-flex align-center mb-2">
                  <div class="mr-2">Copy From: {{ dateRangeCopyFrom }}</div>
                </div>
              </v-col>

              <!-- Copy To -->
              <v-col cols="6" sm="12" md="6">
                <div class="d-flex align-center mb-2">
                  <div class="mr-2">Copy To: {{ copyDateRangeTo }}</div>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <!-- Copy From Calendar -->
              <v-col cols="12" sm="12" md="6" class="py-2">
                <v-card class="custom-calendar-card">
                  <v-date-picker
                    class="custom-calendar-picker"
                    no-title
                    scrollable
                    range
                    v-model="selectedDateFrom"
                    :events="selectedDateFrom"
                    @input="handleDateFromSelection($event)"
                  ></v-date-picker>
                </v-card>
              </v-col>

              <!-- Copy To Calendar -->
              <v-col cols="12" sm="12" md="6">
                <v-card class="custom-calendar-card">
                  <v-date-picker
                    class="custom-calendar-picker"
                    no-title
                    scrollable
                    range
                    v-model="selectedDateTo"
                    :events="dateInRange"
                    event-color="highlighted"
                    @input="handleDateToSelection"
                  ></v-date-picker>
                </v-card>
              </v-col>
            </v-row>

            <v-row class="modal-row">
              <!-- Shifts Count -->
              <v-col cols="4" sm="4" md="4">
                <v-icon>mdi-clock</v-icon>
                {{ shiftsCount }} Shifts
              </v-col>

              <!-- Employees Count -->
              <v-col cols="4" sm="4" md="4">
                <v-icon>mdi-account</v-icon>
                {{ employeesCount }} Employees
              </v-col>

              <!-- Houses Count -->
              <v-col cols="4" sm="4" md="4">
                <v-icon>mdi-home</v-icon>
                {{ housesCount }} Houses
              </v-col>
            </v-row>
          </v-col>

          <v-divider class="vertical-divider"></v-divider>

          <v-col class="modal-row" md="4" lg="4" sm="12">
            <p class="mt-3">Options</p>
            <v-radio-group
              v-model="copyOption"
              @change="handleCopyOptionChange"
              required
            >
              <v-row>
                <v-radio label="Copy Shifts Only" value="shiftsOnly"></v-radio>
              </v-row>
              <v-row>
                <v-radio
                  label="Copy Shifts and Employee Assignments"
                  value="shiftsAndAssignments"
                ></v-radio>
              </v-row>
            </v-radio-group>
            <div v-if="!copyOption" class="error-message">
              Note: Select an option.
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-select
              multiple
              v-model="selectedHouses"
              :items="houses"
              item-text="Name"
              item-value="_id"
              label="Filter Houses"
              clearable
              clear-icon="mdi-close-circle-outline"
              @change="getEvents"
            >
            </v-select>
            <v-data-table
              v-model="selectedShifts"
              :headers="headers"
              :items="shifts"
              item-key="shiftId"
              sort-asc
              show-select
              fixed-header
              class="elevation-1"
              :loading="isLoading"
              loading-text="Loading Data"
              height="500"
              :items-per-page="100"
            >
              <template v-slot:top>
                <v-dialog v-model="dialog" max-width="100%">
                  <v-card>
                    <v-card-title style="background-color: #2b3990">
                      <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-form ref="form" lazy-validation>
                          <v-row>
                            <v-col cols="12" sm="12" md="6">
                              <v-datetime-picker
                                v-model="newClockIn"
                                :text-field-props="textFieldProps"
                                :date-picker-props="startDateProps"
                                :time-picker-props="startTimeProps"
                                time-format="hh:mm a"
                                date-format="yyyy-MM-dd"
                                label="Clock In"
                              ></v-datetime-picker>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                              <v-datetime-picker
                                v-model="newClockOut"
                                :text-field-props="textFieldProps"
                                :date-picker-props="endDateProps"
                                :time-picker-props="endTimeProps"
                                time-format="hh:mm a"
                                date-format="yyyy-MM-dd"
                                label="Clock Out"
                              ></v-datetime-picker>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                              <v-select
                                :items="clients"
                                item-text="Name"
                                item-value="_id"
                                label="Client(s)"
                                v-model="newClient"
                                @input="getSelectedClient"
                                multiple
                              />
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                              <v-autocomplete
                                v-model="newHouse"
                                :items="houses"
                                item-text="Name"
                                item-value="_id"
                                label="Houses"
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                              <v-text-field
                                v-model="newNote"
                                label="Note"
                                single-line
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="ma-1 desktop white--text"
                        color="blue darken-1"
                      >
                        Update
                      </v-btn>
                      <v-btn
                        class="ma-1 desktop white--text"
                        color="red darken-1"
                        text
                        @click="close"
                      >
                        Cancel
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>

              <template v-slot:item.Notes="{ item }">
                <v-text-field
                  v-model="editedItem.Notes"
                  :hide-details="true"
                  dense
                  single-line
                  v-if="item.id === editedItem.id"
                ></v-text-field>
                <span v-else>{{ item.Notes }}</span>
              </template>
              <template v-slot:item.StartDate="{ item }">
                <v-text-field
                  v-model="editedItem.StartDate"
                  :text-field-props="textFieldProps"
                  :date-picker-props="endDateProps"
                  :time-picker-props="endTimeProps"
                  :hide-details="true"
                  time-format="hh:mm a"
                  date-format="yyyy-MM-dd"
                  label="Clock In"
                  autofocus
                  v-if="item.id === editedItem.id"
                ></v-text-field>
                <span v-else>
                  <v-text-field
                    v-model="item.StartDate"
                    disabled
                  ></v-text-field>
                </span>
              </template>
              <template v-slot:item.EndDate="{ item }">
                <v-text-field
                  v-model="editedItem.EndDate"
                  :text-field-props="textFieldProps"
                  :date-picker-props="endDateProps"
                  :time-picker-props="endTimeProps"
                  :hide-details="true"
                  time-format="hh:mm a"
                  date-format="yyyy-MM-dd"
                  label="Clock Out"
                  autofocus
                  v-if="item.id === editedItem.id"
                ></v-text-field>
                <span v-else>
                  <v-text-field v-model="item.EndDate" disabled></v-text-field>
                </span>
              </template>
              <template v-slot:item.ClientID="{ item }">
                <v-select
                  :items="clients"
                  item-text="Name"
                  item-value="_id"
                  label="Client(s)"
                  v-model="editedItem.ClientID"
                  multiple
                  v-if="item.id === editedItem.id"
                />
                <span v-else>
                  <v-select
                    disabled
                    :items="clients"
                    item-text="Name"
                    item-value="_id"
                    label="Client(s)"
                    v-model="item.ClientID"
                    multiple
                  />
                </span>
              </template>
              <template v-slot:item.HouseID="{ item }">
                <v-autocomplete
                  v-model="editedItem.HouseID"
                  :items="houses"
                  item-text="Name"
                  item-value="_id"
                  label="Houses"
                  v-if="item.id === editedItem.id"
                ></v-autocomplete>
                <span v-else>
                  <v-autocomplete
                    disabled
                    v-model="item.HouseID"
                    :items="houses"
                    item-text="Name"
                    item-value="_id"
                    label="Houses"
                  ></v-autocomplete>
                </span>
              </template>

              <template v-slot:item.actions="{ item }">
                <div v-if="item.id === editedItem.id">
                  <v-icon color="red" class="mr-3" @click="closeItem">
                    mdi-window-close
                  </v-icon>
                  <v-icon color="green" @click="saveItem">
                    mdi-content-save
                  </v-icon>
                </div>
                <div v-else>
                  <v-icon color="green" class="mr-3" @click="editItem(item)">
                    mdi-pencil
                  </v-icon>
                  <v-icon color="red" @click="deleteItem(item)">
                    mdi-delete
                  </v-icon>
                </div>
              </template>

              <template v-slot:items="props">
                <tr
                  @click="activerow(props.item)"
                  :class="{ primary: props.item._id === selectedId }"
                >
                  <td>{{ props.item.Name }}</td>
                  <td class="text-xs-right">{{ props.item.Notes }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
              {{ snackText }}

              <template v-slot:action="{ attrs }">
                <v-btn v-bind="attrs" text @click="snack = false">
                  Close
                </v-btn>
              </template>
            </v-snackbar>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="ma-1 black--text"
          v-if="isHideButton"
          @click="copyScheduleDialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          class="ma-1 white--text"
          v-if="isHideButton"
          color="green darken-1"
          @click="handleCopySchedule"
        >
          Copy Schedule
        </v-btn>
        <!--                <v-btn class="ma-1 desktop white&#45;&#45;text" v-if="isShowButton" color="blue darken-1" @click="getEvents">-->
        <!--                    Generate-->
        <!--                </v-btn>-->
        <!--                <v-btn class="ma-1 white&#45;&#45;text" v-if="isHideButton" color="green darken-1"-->
        <!--                       @click="saveSchedule">-->
        <!--                    Save-->
        <!--                </v-btn>-->
        <!--                <v-btn class="ma-1 desktop white&#45;&#45;text" v-if="isHideButton" color="blue darken-1"-->
        <!--                       @click="resetSchedule">-->
        <!--                    Reset-->
        <!--                </v-btn>-->
      </v-card-actions>
    </v-card>
    <v-bottom-sheet v-model="sheet">
      <v-sheet class="" height="500px">
        <v-card-actions class="justify-center">
          <v-btn
            class="ma-1 desktop white--text"
            color="red"
            @click="sheet = !sheet"
          >
            Close
          </v-btn>
        </v-card-actions>

        <div>
          <template>
            <v-simple-table fixed-header height="400px">
              <template v-slot:default>
                <thead>
                  <tr class="text-uppercase">
                    <th class="white--text text-left grey darken-2">Name</th>
                    <th class="white--text text-left grey darken-2">
                      Clocked In
                    </th>
                    <th class="white--text text-left grey darken-2">
                      Clocked Out
                    </th>
                    <th class="white--text text-left grey darken-2">Client</th>
                    <th class="white--text text-left grey darken-2">House</th>
                    <th class="white--text text-left grey darken-2">Notes</th>
                    <th class="white--text text-left grey darken-2">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in resultsSchedule"
                    :key="item[0].ShiftID"
                    :class="item[0].Class"
                  >
                    <td>{{ item[0].EmployeeName }}</td>
                    <td>{{ item[0].StartDate }}</td>
                    <td>{{ item[0].EndDate }}</td>
                    <td>
                      <v-select
                        disabled
                        v-model="item[0].ClientID"
                        :items="clients"
                        item-text="Name"
                        item-value="_id"
                        multiple
                      />
                    </td>
                    <td>
                      <v-autocomplete
                        disabled
                        v-model="item[0].HouseID"
                        :items="houses"
                        item-text="Name"
                        item-value="_id"
                      ></v-autocomplete>
                    </td>
                    <td>{{ item[0].Notes }}</td>
                    <td>{{ item[0].Status }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import UnitService from "@/service/unit.service";
import ShiftService from "@/service/shift.service";
import DateTimeUtil from "../../utils/date-time.util";
import Swal from "sweetalert2";
import { displayError } from "@/service/notification-message.service";

export default {
  props: {
    houses: Array,
    clients: Array,
    calendarType: String,
    eventInfo: Object,
  },
  data() {
    return {
      dialog: false,
      menuFrom: false,
      menuTo: false,
      dateFrom: moment(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      )
        .utc()
        .subtract(1, "weeks")
        .startOf("week")
        .format("YYYY-MM-DD"),
      dateTo: moment(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      )
        .utc()
        .subtract(1, "weeks")
        .endOf("week")
        .format("YYYY-MM-DD"),
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Shift Start Date", value: "StartDate" },
        { text: "Shift End Date", value: "EndDate" },
        { text: "Client", value: "Client" },
        { text: "Houses", value: "HouseID" },
        { text: "Notes", value: "Notes" },
        // {text: "Actions", value: "actions", sortable: false},
      ],
      isLoading: false,
      shifts: [],
      responseDataShifts: [],
      selectedShifts: [],
      selectedHouses: [],
      selectedId: "",
      titleForm: "Update Schedule",
      newClockIn: "",
      newClockOut: "",
      newClient: "",
      newHouse: "",
      newNote: "",
      calendarTypes: ["day", "week", "2weeks", "month"],
      textFieldProps: {
        appendIcon: "event",
      },
      startDateProps: {
        min: moment(new Date()).format("YYYY-MM-DD"),
      },
      startTimeProps: {
        ampmInTitle: true,
      },
      endDateProps: {
        min: moment(new Date()).format("YYYY-MM-DD"),
      },
      endTimeProps: {
        ampmInTitle: true,
      },
      snack: false,
      snackColor: "",
      snackText: "",
      sheet: false,
      resultsSchedule: [],
      isShowButton: true,
      isHideButton: false,
      editedIndex: -1,
      editedItem: {
        id: 0,
        Notes: "",
      },
      defaultItem: {
        id: 0,
        Notes: "",
      },
      userRole: localStorage.getItem("userRole"),
      userPrograms: localStorage.getItem("userPrograms"),
      userProgramsList: [],
      msg: false,
      text: "",
      selectedDateTo: [],
      employeesCount: [],
      housesCount: [],
      shiftsCount: [],
      copyOption: "",
      newlyCopiedShifts: [],
      selectedDateFrom: [],
      selectedCalendarType: this.calendarType || "",
      filteredShifts: [],
    };
  },

  computed: {
    copyScheduleDialog: {
      get() {
        return this.$store.state.shifts.copyScheduleDialog;
      },
      set(val) {
        this.$store.commit("shifts/SET_COPY_SCHEDULE_DIALOG", val);
      },
    },

    dateRangeCopyFrom() {
      if (this.selectedDateFrom && this.selectedDateFrom.length === 2) {
        const formattedStartDate = this.formatDate(this.selectedDateFrom[0]);
        const formattedEndDate = this.formatDate(this.selectedDateFrom[1]);
        return `${formattedStartDate} ~ ${formattedEndDate}`;
      }
      return "";
    },

    copyDateRangeTo() {
      const formattedStartDate = moment(this.selectedDateTo[0]).format(
        "YYYY-MM-DD"
      );
      const formattedEndDate = moment(this.selectedDateTo[1]).format(
        "YYYY-MM-DD"
      );
      return `${formattedStartDate} ~ ${formattedEndDate}`;
    },
  },

  created() {
    this.userProgramsList = this.userPrograms
      ? JSON.parse(this.userPrograms)
      : [];

    if (this.eventInfo.start.date && this.eventInfo.end.date) {
      this.selectedDateFrom = [
        this.eventInfo.start.date,
        this.eventInfo.end.date,
      ];
    }
  },

  mounted() {
    if (this.eventInfo) {
      this.getEvents();
    }

    this.selectedDateFrom = this.dates();
  },

  watch: {
    copyScheduleDialog(val) {
      if (val === false) {
        this.resetSchedule();
      }
    },

    selectedDateFrom: {
      deep: true,
      async handler() {
        await this.getEvents();
      },
    },
  },

  methods: {
    ...mapActions("shifts", ["getSchedule", "saveCopySchedule"]),

    close() {
      this.dialog = false;
    },

    async getEvents() {
      this.showProgressNotification("Please wait while fetching data.");
      this.loading = true;

      let startDate =
        this.selectedDateFrom[0] ||
        (this.eventInfo && this.eventInfo.start.date);

      if (startDate) {
        startDate = DateTimeUtil.toUTCISOString(
          DateTimeUtil.toStartOfDay(startDate)
        );
      }

      let endDate =
        this.selectedDateFrom[1] || (this.eventInfo && this.eventInfo.end.date);

      if (endDate) {
        endDate = DateTimeUtil.toUTCISOString(DateTimeUtil.toEndOfDay(endDate));
      }

      if (!this.selectedHouses || this.selectedHouses.length === 0) {
        this.unitIds = this.houses.map((house) => house._id).join(",");
      } else {
        if (Array.isArray(this.selectedHouses)) {
          this.unitIds = this.selectedHouses.join(",");
        } else {
          this.unitIds = this.selectedHouses;
        }
      }

      try {
        const params = {
          startDate,
          endDate,
          unitIds: this.unitIds,
          includeExtendedShifts: false,
        };

        const response = await ShiftService.get(params);
        const shifts = response.data.shifts;
        this.responseDataShifts = shifts;
        this.shifts = this.mapShiftsForDisplay(shifts);
        this.shiftsCount = this.filteredShifts.length;
        this.calculateEmployeesCount();
        this.calculateHousesCount();
        Swal.close();
      } catch (e) {
        this.msg = true;
        this.text = e.response.data.msg;
        this.color = "red";
      } finally {
        this.loading = false;
        this.isHideButton = true;
      }
    },

    async getUnitIds() {
      const userRolesThatFiltersByHouse = [
        "Administration",
        "Program Coordinator",
        "Client Services Manager",
        "Human Resources",
        "Compliance Manager",
      ];
      let unitIds = "";

      if (userRolesThatFiltersByHouse.includes(this.userRole)) {
        unitIds =
          this.selectedHouses && this.selectedHouses.length > 0
            ? this.selectedHouses.toString()
            : "ALL";
      } else {
        try {
          const response = await UnitService.getIdsByNames(
            this.userProgramsList
          );
          unitIds = response.data.toString();
        } catch (e) {
          unitIds = "";
        }
      }

      return unitIds;
    },

    mapShiftsForDisplay(shifts) {
      if (!shifts) {
        return [];
      }

      let count = 1;
      this.filteredShifts = shifts.filter(
        (shift) => shift.isRecurringEvent === "No" && shift.Status === "1"
      );

      return this.filteredShifts.map((shift) => {
        const start = moment(shift.StartDate).format("YYYY-MM-DD hh:mm A");
        const end = moment(shift.EndDate).format("YYYY-MM-DD hh:mm A");

        return {
          id: count++,
          shiftId: shift._id,
          name: shift.EmployeeName,
          date: moment(shift.StartDate).format("YYYY-MM-DD"),
          StartDate: start,
          EndDate: end,
          EmployeeID: shift.employee,
          Client: shift.ClientName,
          ClientID: shift.ClientId,
          House: shift.unitsName,
          HouseID: shift.units,
          StartUTCDate: DateTimeUtil.toLocalDateTime(shift.StartDate),
          EndUTCDate: DateTimeUtil.toLocalDateTime(shift.EndDate),
        };
      });
    },

    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Intl.DateTimeFormat(undefined, options).format(new Date(date));
    },

    handleDateToSelection(date) {
      if (!this.selectedShifts.length) {
        Swal.fire("Select what shifts to copy");
        return;
      }

      if (!this.selectedDateTo.length) {
        this.selectedDateTo.push(date);
      } else {
        switch (this.selectedCalendarType) {
          case "week":
          case "2weeks": {
            const period = "weeks";
            const daysToAdd = this.selectedCalendarType === "week" ? 6 : 13;

            const copyFromStartDate = this.selectedDateFrom[0];
            const copyToStartDate = this.selectedDateTo[0];
            const difference = moment(copyToStartDate).diff(
              moment(copyFromStartDate)
            );
            const duration = moment.duration(difference);
            const copyFromAndCopyToPeriodDifference = duration.asWeeks();

            this.selectedShifts.forEach((shift) => {
              const newStartDateMoment = moment(shift.StartDate).add(
                copyFromAndCopyToPeriodDifference,
                period
              );
              const newEndDateMoment = moment(shift.EndDate).add(
                copyFromAndCopyToPeriodDifference,
                period
              );

              this.newlyCopiedShifts.push({
                shiftId: shift.shiftId,
                startDate: DateTimeUtil.toUTCISOString(
                  newStartDateMoment.toDate()
                ),
                endDate: DateTimeUtil.toUTCISOString(newEndDateMoment.toDate()),
              });
            });

            this.selectedDateTo.push(
              moment(this.selectedDateTo[0])
                .add(daysToAdd, "days")
                .format("YYYY-MM-DD")
            );
            break;
          }
          case "month": {
            const copyFromStartDate = this.selectedDateFrom[0];
            const copyToStartDate = this.selectedDateTo[0];
            const difference = moment(copyToStartDate).diff(
              moment(copyFromStartDate)
            );
            const duration = moment.duration(difference);
            const copyFromAndCopyToMonthDifference = duration.asMonths();

            this.selectedShifts.forEach((shift) => {
              const newStartDateMoment = moment(shift.StartDate).add(
                copyFromAndCopyToMonthDifference,
                "months"
              );
              const newEndDateMoment = moment(shift.EndDate).add(
                copyFromAndCopyToMonthDifference,
                "months"
              );

              this.newlyCopiedShifts.push({
                shiftId: shift.shiftId,
                startDate: DateTimeUtil.toUTCISOString(
                  newStartDateMoment.toDate()
                ),
                endDate: DateTimeUtil.toUTCISOString(newEndDateMoment.toDate()),
              });
            });

            this.selectedDateTo.push(
              moment(this.selectedDateTo[0])
                .add(1, "months")
                .subtract(1, "days")
                .format("YYYY-MM-DD")
            );
            break;
          }
          case "day": {
            const copyFromStartDate = this.selectedDateFrom[0];
            const copyToStartDate = this.selectedDateTo[0];
            const difference = moment(copyToStartDate).diff(
              moment(copyFromStartDate)
            );
            const duration = moment.duration(difference);
            const copyFromAndCopyToDayDifference = duration.asDays();

            this.selectedShifts.forEach((shift) => {
              const newStartDateMoment = moment(shift.StartDate).add(
                copyFromAndCopyToDayDifference,
                "days"
              );
              const newEndDateMoment = moment(shift.EndDate).add(
                copyFromAndCopyToDayDifference,
                "days"
              );

              this.newlyCopiedShifts.push({
                shiftId: shift.shiftId,
                startDate: DateTimeUtil.toUTCISOString(
                  newStartDateMoment.toDate()
                ),
                endDate: DateTimeUtil.toUTCISOString(newEndDateMoment.toDate()),
              });
            });

            this.selectedDateTo.push(
              moment(this.selectedDateTo[0]).add(1, "days").format("YYYY-MM-DD")
            );
            break;
          }
          default:
            this.selectedDateTo.push(date);
            break;
        }
      }
    },

    handleDateFromSelection(date) {
      if (!this.selectedDateFrom.length) {
        this.selectedDateFrom.push(date);
      } else {
        switch (this.selectedCalendarType) {
          case "week": {
            this.selectedDateFrom.push(
              moment(this.selectedDateFrom[0])
                .add(6, "days")
                .format("YYYY-MM-DD")
            );
            break;
          }
          case "2weeks": {
            this.selectedDateFrom.push(
              moment(this.selectedDateFrom[0])
                .add(13, "days")
                .format("YYYY-MM-DD")
            );
            break;
          }
          case "month": {
            const endDate = moment(this.selectedDateFrom[0])
              .add(1, "months")
              .subtract(1, "days")
              .format("YYYY-MM-DD");
            this.selectedDateFrom.push(endDate);
            break;
          }
          case "day": {
            this.selectedDateFrom.push(this.selectedDateFrom[0]);
            break;
          }
          default:
            this.selectedDateFrom.push(date);
            break;
        }
      }
    },

    dateInRange(date) {
      if (this.selectedDateTo.length === 2) {
        let startDate = moment(this.selectedDateTo[0]);
        let endDate = moment(this.selectedDateTo[1]);
        let current = moment(date);
        return current.isBetween(startDate, endDate, "days", "[]"); // '[]' includes start and end dates
      }
      return false;
    },

    calculateEmployeesCount() {
      const uniqueEmployeeIDs = [
        ...new Set(this.shifts.map((shift) => shift.EmployeeID)),
      ];
      this.employeesCount = uniqueEmployeeIDs.length;
    },

    calculateHousesCount() {
      const uniqueHouseIDs = [
        ...new Set(this.shifts.map((shift) => shift.HouseID)),
      ];
      this.housesCount = uniqueHouseIDs.length;
    },

    handleCopyOptionChange(option) {
      this.copyOption = option;
    },

    handleCopySchedule() {
      if (!this.selectedDateTo.length || !this.copyOption) {
        let errorMessage = "";

        if (!this.selectedDateTo.length && !this.copyOption) {
          errorMessage =
            "Please select a date where to copy the shifts and a copy option";
        } else if (!this.selectedDateTo.length) {
          errorMessage = "Please select a date where to copy the shifts";
        } else {
          errorMessage = "Please select a copy option for the shifts";
        }

        Swal.fire({
          icon: "warning",
          title: "Incomplete Selection",
          text: errorMessage,
        });

        return;
      }

      if (this.copyOption === "shiftsOnly") {
        this.copyShiftsOnlyMethod();
      } else if (this.copyOption === "shiftsAndAssignments") {
        this.copyShiftsAndAssignmentsMethod();
      }
    },

    async copyShiftsOnlyMethod() {
      if (!this.newlyCopiedShifts) {
        console.log("No items to copy");
        return;
      }

      try {
        const payload = {
          shiftsData: this.newlyCopiedShifts,
        };

        const response = await ShiftService.copySchedule(payload);
        this.copyScheduleDialog = false;
        this.$emit("copyShift", response.data);
      } catch (error) {
        displayError(error.message);
      }
    },

    async copyShiftsAndAssignmentsMethod() {
      if (!this.newlyCopiedShifts) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No items to copy",
        });
        return;
      }

      try {
        const payload = {
          shiftsData: this.newlyCopiedShifts,
        };

        await ShiftService.copySchedule(payload);

        this.copyScheduleDialog = false;
        let emitValue = { text: "Shifts copied successfully" };
        this.$emit("copyShift", emitValue);
      } catch (error) {
        console.log({ error });
        this.text = error.response.data.error;
        this.msg = true;

        Swal.fire({
          icon: "error",
          title: "Error",
          text: this.text,
        });
      }
    },

    dates() {
      let startDate,
        endDate,
        monthCopySchedule,
        month,
        year,
        firstDate,
        lastDate,
        monthFirstDate,
        monthLastDate,
        start2WeeksDate,
        end2WeeksDate;

      switch (this.selectedCalendarType) {
        case "week":
          startDate = this.eventInfo.start.date;
          endDate = this.eventInfo.end.date;
          return [startDate, endDate];

        case "month":
          monthCopySchedule = this.eventInfo.title;
          [month, year] = monthCopySchedule.split(" ");

          firstDate = new Date(
            year,
            new Date(Date.parse(month + " 1")).getMonth(),
            1
          );
          lastDate = new Date(
            year,
            new Date(Date.parse(month + " 1")).getMonth() + 1,
            0
          );

          monthFirstDate = this.toLocalISOString(firstDate);
          monthLastDate = this.toLocalISOString(lastDate);

          return [monthFirstDate, monthLastDate];

        case "2weeks":
          start2WeeksDate = this.eventInfo.start.date;
          end2WeeksDate = moment(start2WeeksDate)
            .add(13, "days")
            .format("YYYY-MM-DD"); // adds 13 days to start date
          return [start2WeeksDate, end2WeeksDate];

        default:
          return [];
      }
    },

    toLocalISOString(date) {
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);

      return `${year}-${month}-${day}`;
    },

    getSelectedClient(value) {
      console.log(value);
      /*
      this.newClient = value;
      value.forEach((element)=>{

      });
      */
    },

    showProgressNotification() {
      Swal.fire({
        title: "Fetching data...",
        html: "Please wait while the data is being fetched.",
        icon: "info",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    },
  },
};
</script>

<style scoped>
.date-field > input {
  text-align: center !important;
}

.error-message {
  color: red;
  margin-top: 10px;
}

.custom-calendar-card {
  border: none !important;
  box-shadow: none !important;
}

.custom-calendar-picker {
  width: 100% !important;
}

.highlighted {
  border-radius: 50%;
  background: lightblue;
}

.vertical-line {
  width: 1px;
  background-color: #b8bbbd;
  margin-top: 100px;
  height: 70%;
}

.vertical-divider {
  background-color: #b8bbbd;
  transform: rotate(90deg);
  width: 1px !important;
  height: 90%;
  margin-top: 100px;
}

.modal-row {
  background-color: white;
}

@media (max-width: 960px) {
  /* hide on small and medium screens */
  .vertical-divider {
    display: none;
  }
}
</style>
